// Standard
// {
//   data: object,
//   labels: object,
//   parent: object,
// }


// Axis
// {
//   axis: object,
//   axisLabel: object
//   grid: object
//   ticks: object
//   tickLabels: object
// }



export default {

  // Gradient definition (keep hidden)
  gradientDefinition: {
    position: 'absolute',
    pointerEvents: 'none',
  },

  // Chart
  chart: {
  },

  // Tide line
  tideLine: {
    data: {
      stroke: "url(#tideLineGradient)",
      strokeWidth: '5'
    }
  },
  tideLineBorder: {
    data: {
      stroke: "#FFF",
      strokeWidth: '8'
    }
  },

  // Tide dots
  highTideDot: {
    data: {
      fill: '#84CCD6',
      stroke: '#FFF',
      strokeWidth: '4',
      // size must be declared as a property on the component itself
    },
  },
  lowTideDot: {
    data: {
      fill: '#CCAA7A',
      stroke: '#FFF',
      strokeWidth: '4',
      // size must be declared as a property on the component itself
    },
  },

  // Tide label white backings
  tideLabelBacking: {
    fill: 'rgba(255,255,255,0.5)'
  },

  // Tide labels
  tideLabel: {
    data: {
      fill: 'transparent',
      stroke: 'transparent',
    },
    labels: {
      fontFamily: 'Catamaran',
      fill: '#4C5C68',
      stroke: 'transparent',
      fontWeight: '300',
      fontSize: '15px'
    },
  },

  // Height axis
  heightAxis: {
    axis: {
      stroke: '#ccc',
      strokeWidth: '0',
    },
    ticks: {
    },
    tickLabels: {
      fontFamily: 'Catamaran',
      fontSize: '15',
      fill: '#FFF',
      stroke: 'transparent',
      fontWeight: '300'
    },
    grid: {
      stroke: '#E6EBE0',
      strokeDasharray: '3, 3'
    }
  },

  // Mean water lines
  meanHighWater: {
    data: {
      stroke: '#84CCD6',
      strokeWidth: '2',
      strokeDasharray: '5, 2',
    },
  },
  meanLowWater: {
    data: {
      stroke: '#CCAA7A',
      strokeWidth: '2',
      strokeDasharray: '5, 2',
    },
  },

  // Now line
  nowLineBacking: {
    data: {
      stroke: 'rgba(237, 106, 90, 0.1)',
      strokeWidth: '20',
    }
  },
  nowLine: {
    data: {
      stroke: '#ED6A5A',
      strokeWidth: '2'
    },
  },

  // Now label
  nowLabelBacking: {
    fill: '#ED6A5A'
  },
  nowLabel: {
    fill: '#FFF',
    stroke: 'transparent',
    fontFamily: 'Catamaran',
    fontSize: '14px',
    fontWeight: '500',
    textShadow: '1px 1px 1px rgba(0, 0, 0, 0.27)',
  },
}



// WEBPACK FOOTER //
// ./src/components/DayPage/TideGraphStyles.js